import Base from "./base";

class User extends Base {
    BASE_PATH = ""

    //登录
    login(username, password) {
        return this.runPost("/login", {
            username: username,
            password: password
        })
    }

    //用户信息
    info() {
        return this.runGet("/info")
    }

    //登出
    logout() {
        return this.runGet("/logout")
    }
}

export default User